import { request } from 'src/api/request';
import { exists } from 'src/utils/exists/exists';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';

interface GetExportProps {
  fileType: string;
  fileName: string;
  searchParams: {
    page: number;
    pageSize: number;
    sort: any;
    order: any;
    sort_search: any;
    q: string;
    reps: string[];
    activityTypes: string[];
    categories: string[];
    statuses: {
      [key: string]: string[];
    };
    timeframe: string;
  };
}

export const getActivityExport = async ({
  searchParams,
  fileType,
  fileName,
}: GetExportProps) => {
  const {
    sort,
    order,
    page,
    pageSize,
    q,
    reps,
    activityTypes,
    categories,
    statuses,
    timeframe,
  } = searchParams;
  const queryParams = getSearchQueryParamsForAPI({
    sort,
    order,
    page: page + 1,
    pageSize,
    q,
  });

  const compileFilterQuery = (key: string, items: any[]) =>
    items?.length ? items.map((item) => `${key}=${item}`).join('&') : undefined;

  const repQuery = compileFilterQuery('rep', reps);
  const activityQuery = compileFilterQuery('activity_type', activityTypes);
  const categoryQuery = compileFilterQuery('category', categories);

  const formatStatusQuery = () => {
    const compiledStatuses = [];

    statuses &&
      Object.entries(statuses).forEach(([crm_type, statusArray]) => {
        (statusArray as string[]).forEach((crm_status) => {
          compiledStatuses.push({ crm_type, crm_status });
        });
      });

    return compiledStatuses
      .map(
        (status, index) =>
          `crm_type_${index + 1}=${status.crm_type}&crm_status_${index + 1}=${
            status.crm_status
          }`
      )
      .join('&');
  };

  const statusQuery = formatStatusQuery();

  const timeframeQuery = exists(timeframe)
    ? `time_range=${timeframe}`
    : undefined;

  const queryString = [
    queryParams,
    repQuery,
    activityQuery,
    categoryQuery,
    statusQuery,
    timeframeQuery,
  ]
    .filter(Boolean)
    .join('&');

  const columns = [
    'activity_type',
    'category',
    'provider.provider_id',
    'provider.name',
    'provider.address_line_1',
    'provider.city',
    'provider.state',
    'owner',
    'activity_date',
    'created_at',
    'provider.crm_links',
    'provider.crm_status',
    'details',
  ];

  const url = `https://api.medscout.io/api/v1/medrm/activity/${queryString}`;

  return request({
    url: '/v1/admin/export/',
    method: 'POST',
    data: {
      url,
      file_format: fileType,
      fileName,
      columns,
    },
  });
};
